import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React, { Component } from 'react';
import { LongTextInput } from "react-admin";

const style = {
  container: {
    position: "relative",
  },
  error: {
    color: "#d23931",
  },
  success: {
    color: "#3ad231",
  },
  stage: {
    position: "absolute",
  },
  guard: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
};

class KidScriptValidationRulesInput extends Component {
  static propTypes = {
    kidScript: PropTypes.string,
    rules: PropTypes.string,
    source: PropTypes.string.isRequired,
  };

  static defaultProps = {
    sort: false,
    sortable: false,
    alwaysOn: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      kidScript: props.kidScript,
      rules: props.rules,
      status: null, // valid, invalid or validating
      timeoutHandler: null,
    };
  }

  componentDidMount() {
    this.setState({
      error: null,
      status: "validating",
    });
    this.testKidScript();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.kidScript !== prevState.kidScript ||
      JSON.stringify(this.state.rules) !== JSON.stringify(prevState.rules)
    ) {
      this.testKidScript();
    }
  }

  componentWillReceiveProps(nextProps) {
    const newState = {};
    if (nextProps.kidScript !== this.state.kidScript) {
      newState.kidScript = nextProps.kidScript;
    }
    if (JSON.stringify(this.state.rules) !== JSON.stringify(nextProps.rules)) {
      newState.rules = this.jsonParse(nextProps.rules);
    }
    if (Object.keys(newState).length) {
      this.setState(
        Object.assign(newState, {
          error: null,
          status: "validating",
          eventSamples: [],
        })
      );
    }
  }

  // the activity's sample KidScript as JSON, and its rule applied to it, the way platform's
  // activity tester does (kidscript-activity-tester, src/functions/main/handler.ts): the sample is
  // the project's head, with an empty body, and the library's catalog loaded first
  testKidScript() {
    const { kidScript, rules } = this.state;
    KidScript.library.requireCatalog().then(
      () => {
        try {
          // the sample has no cursor
          const project = KidScript.parseDocuments([kidScript, ""], KidScript.Version, { cursorLine: null });
          const jsonLogicKidScript = project.toJSON();
          // platform tests every activity's rule at once, so the tester takes a list of them
          const [result] = project.activityTester([rules]);
          if (result.parsed) {
            this.setState({
              jsonLogicKidScript,
              error: null,
              jsonLogicStatus: result.jsonLogicStatus,
              jsonLogicResultCount: result.jsonLogicResultCount,
              // by the count, as platform awards an activity only when it's above 0: the rule's
              // result can be an empty list, which is truthy
              status: result.jsonLogicResultCount > 0 ? "valid" : "invalid",
            });
          } else {
            // the rule threw
            this.setState({
              jsonLogicKidScript,
              error: result.error,
              jsonLogicStatus: null,
              status: "invalid",
            });
          }
        } catch (error) {
          // compiling throws for mistakes in the sample
          this.setState({
            jsonLogicKidScript: null,
            error: error.toString(),
            jsonLogicStatus: null,
            status: "invalid",
          });
        }
      },
      // the library's catalog didn't load
      (error) => {
        this.setState({
          jsonLogicKidScript: null,
          error: String(error),
          jsonLogicStatus: null,
          status: "invalid",
        });
      }
    );
  }

  jsonStringify(value) {
    if (typeof value === "string") {
      return value;
    }
    try {
      return JSON.stringify(value, null, 2);
    } catch (error) {
      return value;
    }
  }

  jsonParse(value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return value;
    }
  }

  validateKidScript() {
    if (this.state.status !== "valid") {
      return "failed";
    }
  }

  render() {
    const {
      status,
      jsonLogicKidScript,
      jsonLogicResultCount,
      error,
      jsonLogicStatus,
    } = this.state;
    const { classes, kidScript, rules, ...props } = this.props;
    return (
      <>
        <div>
          <pre>
            {JSON.stringify(jsonLogicKidScript, null, 2)}
          </pre>
        </div>
        <LongTextInput
          format={(value) => value && this.jsonStringify(value)}
          parse={(value) => this.jsonParse(value)}
          {...props}
          //validate={() => this.validateKidScript()}
        />
        <div>
          <pre>
            {JSON.stringify(jsonLogicStatus, null, 2)}
          </pre>
        </div>
        <div>
          {status === "invalid" && <div
            className={classes.error}
                                   >
            {error}
          </div>}
          {status === "valid" && (
            <div
              className={classes.success}
            >
              Valid (count:
              {jsonLogicResultCount}
              )
            </div>
          )}
        </div>
      </>
    );
  }
}

export default withStyles(style)(KidScriptValidationRulesInput);
